import FormInputTypes from '../components/atoms/formEnums/formInputTypes';

export default {
  title: 'Shared Experience',
  attributeName: 'sharedExperience',
  helpText: 'This section specifies if the app must enable the “Shared Experience” functionalities and some of its settings. This section is optional and if it’s not defined, all “Shared Experience” functionalities will be disabled.',
  fields: [
    {
      attributeName: 'sharedExperienceEnabled',
      helpText: 'Whether or not the “Shared Experiences” functionalities should be enabled.',
      type: FormInputTypes.CHECKBOX,
      label: 'Enabled',
      placeholder: '',
      default: false,
    },
    {
      attributeName: 'sharedExperienceAutomaticJoin',
      helpText: 'If enabled, the app will automatically look for available friend rooms/parties to join. This behavior is not stable and it’s only recommended for testing purposes.',
      type: FormInputTypes.CHECKBOX,
      label: 'Automatic Join',
      placeholder: '',
      default: false,
    },
    {
      attributeName: 'sharedExperienceEnableICCIndicators',
      helpText: 'If enabled, the ICC map will show icons of the room/party members in the camera they are currently watching.',
      type: FormInputTypes.CHECKBOX,
      label: 'Enable ICC Indicators',
      placeholder: '',
      default: false,
    },
  ],
};
